"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var cell_component_1 = __importDefault(require("./cell.component"));
var MenuMoreOutline_1 = __importDefault(require("../icons/generated/MenuMoreOutline"));
var styled_components_1 = __importDefault(require("styled-components"));
exports.OPEN_EVENT = 'open-table-dropdown';
var MenuMore = styled_components_1.default(MenuMoreOutline_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  fill: ", ";\n  height: 32px;\n  width: 32px;\n"], ["\n  fill: ", ";\n  height: 32px;\n  width: 32px;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colours.table.options;
});
MenuMore.displayName = 'MenuMore';
var IconContainer = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: absolute;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  width: 48px;\n  background-color: ", ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  z-index: 10;\n"], ["\n  position: absolute;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  width: 48px;\n  background-color: ", ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  z-index: 10;\n"])), function (_a) {
    var theme = _a.theme, isOpen = _a.isOpen;
    return (isOpen ? theme.colours.table.optionsBackground : 'transparent');
});
IconContainer.displayName = 'IconContainer';
var TableDropDown = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  display: flex;\n  flex-direction: column;\n  transform: translateY(100%);\n  width: 100px;\n  background-color: ", ";\n  font-size: 14px;\n  padding: 12px;\n  z-index: 12;\n  justify-content: flex-start;\n"], ["\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  display: flex;\n  flex-direction: column;\n  transform: translateY(100%);\n  width: 100px;\n  background-color: ", ";\n  font-size: 14px;\n  padding: 12px;\n  z-index: 12;\n  justify-content: flex-start;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colours.table.optionsBackground;
});
TableDropDown.displayName = 'TableDropDown';
var TableDropDownOption = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  text-align: left;\n  margin-bottom: 4px;\n  &:last-of-type {\n    margin: 0;\n  }\n  color: ", ";\n  cursor: pointer;\n"], ["\n  text-align: left;\n  margin-bottom: 4px;\n  &:last-of-type {\n    margin: 0;\n  }\n  color: ", ";\n  cursor: pointer;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colours.table.optionsColor;
});
TableDropDownOption.displayName = 'TableDropDownOption';
function TableOptions(props) {
    var options = props.options, item = props.item, id = props.id, _a = props.initialOpenState, initialOpenState = _a === void 0 ? false : _a;
    var _b = react_1.useState(initialOpenState), isOpen = _b[0], setIsOpen = _b[1];
    var toggle = function () {
        setIsOpen(!isOpen);
        if (!isOpen) {
            var event_1 = new CustomEvent(exports.OPEN_EVENT, { detail: id });
            document.dispatchEvent(event_1);
        }
    };
    react_1.useEffect(function () {
        var handler = function (e) {
            var customEvent = e;
            if (customEvent.detail !== id) {
                setIsOpen(false);
            }
        };
        document.addEventListener(exports.OPEN_EVENT, handler);
        return function () { return document.removeEventListener(exports.OPEN_EVENT, handler); };
    }, [id]);
    return (react_1.default.createElement(cell_component_1.default, { alignRight: true },
        react_1.default.createElement(IconContainer, { isOpen: isOpen },
            react_1.default.createElement(MenuMore, { onClick: toggle })),
        isOpen && (react_1.default.createElement(TableDropDown, null, options.map(function (_a) {
            var id = _a.id, label = _a.label, action = _a.action;
            return (react_1.default.createElement(TableDropDownOption, { key: id, onClick: function () {
                    setIsOpen(false);
                    action(item);
                } }, label));
        })))));
}
TableOptions.displayName = 'TableOptions';
exports.default = TableOptions;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
